import { ApiProperty } from "@nestjs/swagger";


export class ModuleModel {
    @ApiProperty()
    moduleId: number;
    @ApiProperty()
    moduleName: string;
    @ApiProperty()
    moduleDesc: string;
    @ApiProperty()
    username: string;

    constructor(moduleId: number, moduleName: string, moduleDesc: string, username: string) {
        this.moduleId = moduleId;
        this.moduleDesc = moduleDesc;
        this.moduleName = moduleName;
        this.username = username;
    }
}
